// TODO: delete this folder when cleaning up bulk_operations_floating_toolbar

import React, { useEffect } from 'react';
import type { ReferenceLoader } from '@atlassian/jira-bulk-operations-common/src/utils/reference-loader/use-reference-loader/index.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { ANALYTICS_SOURCE_BACKLOG } from '../../../common/constants/analytics.tsx';
import { useBacklogSelector } from '../../../state/index.tsx';
import { getSelectedCards } from '../../../state/selectors/cards/index.tsx';
import { useShowCheckbox } from '../../../state/state-hooks/use-show-checkbox.tsx';
import { useBulkActionsBar } from './bulk-actions-bar-controller/index.tsx';
import { useCloseGracefully } from './close-gracefully/index.tsx';
import { BULK_ACTIONS_TOOLBAR_TESTID } from './constants.tsx';
import { BulkActionsBarWrapper, StaticContainer } from './styled.tsx';

type BulkActionsBarProps = {
	bulkOperationsToolbarOld?: ReferenceLoader;
};

export const useSelectedCardIds = () => useBacklogSelector(getSelectedCards);

export const BulkActionsBar = ({ bulkOperationsToolbarOld }: BulkActionsBarProps) => {
	const showCheckbox = useShowCheckbox();
	const selectedCardIds = useSelectedCardIds();
	const [{ isOverlaid }, { setIsOpen }] = useBulkActionsBar();

	useEffect(() => {
		setIsOpen(showCheckbox);
	}, [showCheckbox, setIsOpen]);

	const componentStyles = useCloseGracefully();

	return (
		<ContextualAnalyticsData attributes={{ analyticsSource: ANALYTICS_SOURCE_BACKLOG }}>
			<StaticContainer
				// @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & { isOverlaid: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps'.ts(2322)
				css={componentStyles}
				isOverlaid={isOverlaid && showCheckbox}
			>
				<BulkActionsBarWrapper
					data-testid={BULK_ACTIONS_TOOLBAR_TESTID}
					isVisible={!!selectedCardIds.length && showCheckbox}
				>
					{showCheckbox && (
						<div
							data-testid="software-backlog.header.bulk-actions-bar.bulkops-toolbar-container"
							ref={bulkOperationsToolbarOld?.setRef}
						/>
					)}
				</BulkActionsBarWrapper>
			</StaticContainer>
		</ContextualAnalyticsData>
	);
};
